<template>
  <button
    :id="button_id"
    :type="button_type"
    :disabled="is_disabled"
    :class="[button_class, 'px-4 py-2 rounded-[30px] bg-black text-white border-b border-r border-white hover:shadow-lg hover:shadow-white/70 transition-shadow duration-500']">
    {{ button_text }}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    is_disabled: Boolean,
    button_id: String,
    button_class: String,
    button_text: String,
    button_type: {
      type: String,
      default: 'button'
    },
  }
}
</script>